import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./client.ts";

// This will be set by the App component
let toastErrorHandler: ((message: string) => void) | null = null;

export const setQueryErrorHandler = (handler: (message: string) => void) => {
  toastErrorHandler = handler;
};

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
      gcTime: 1000 * 60 * 10, // Keep unused data in cache for 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
      networkMode: "always",
    },
    mutations: {
      onError: (error) => {
        const message =
          error instanceof ApiError
            ? error.message
            : "An unexpected error occurred";
        if (toastErrorHandler) {
          toastErrorHandler(message);
        } else {
          console.error("Error:", message);
        }
      },
    },
  },
});
